import React, { useEffect, useRef } from 'react'
import { App_url } from '../utils/constants/static'
import gsap from 'gsap';

const Draw = () => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const ctxRef = useRef<CanvasRenderingContext2D | null>(null);
  const text = "LET THE THORNS REMAIN REMEMBER YOUR NAME"; // sentence to draw
  const letterIndex = useRef(0);
  const lastDrawPos = useRef({ x: 0, y: 0 });
  const drawDistance = 20; // distance between letters

  interface LetterParticle {
    x: number;
    y: number;
    char: string;
    fontSize: number;
    rotation: number;
    opacity: number;
  }

  const particles = useRef<LetterParticle[]>([]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    ctxRef.current = ctx;

    const resizeCanvas = () => {
      const rect = canvas.getBoundingClientRect();
      canvas.width = rect.width;
      canvas.height = rect.height;
    };
    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);

    const handleMouseMove = (e: MouseEvent) => {
      const rect = canvas.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      const dx = x - lastDrawPos.current.x;
      const dy = y - lastDrawPos.current.y;
      const dist = Math.sqrt(dx * dx + dy * dy);
      const angle = Math.atan2(dy, dx);

      // calculate speed 
      const speed = Math.min(dist, 80); // cap max speed
      const fontSize = 16 + (speed / 80) * 60; // 28–88px range


      // Only draw next letter after moving a certain distance
      const minDistance = Math.max(10, fontSize * 0.45);
      if (dist > minDistance) {
        drawLetter(x, y, fontSize, speed, angle);
        lastDrawPos.current = { x, y };
      }
    };

    const drawLetter = (x: number, y: number, fontSize: number, speed: number, angle: number) => {
      // Get next character
      const currentChar = text[letterIndex.current % text.length];
      letterIndex.current++;

      const opacity = Math.min(1, 0.6 + speed / 100);

      const particle: LetterParticle = {
        x,
        y,
        char: currentChar,
        fontSize,
        rotation: angle,
        opacity,
      };

      particles.current.push(particle);

      // Animate: hold 1 sec, then move upward + fade
      const tl = gsap.timeline({
        onComplete: () => {
          particles.current = particles.current.filter((p) => p !== particle);
        },
      });

      tl.to(particle, {
        opacity: 0.8,
        duration: 1,
        ease: "power3.out"
      }) // stay for 1 second
        .to(particle, {
          y: y - 200,
          opacity: 0,
          duration: 3,
          ease: "power3.out",
        }, "+=0.2");
    };

    const render = () => {
      const ctx = ctxRef.current;
      const canvas = canvasRef.current;
      if (!ctx || !canvas) return;

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // ctx.fillStyle = "rgba(0, 0, 0, 0.05)";
      // ctx.fillRect(0, 0, canvas.width, canvas.height);

      particles.current.forEach((p) => {
        ctx.save();
        ctx.globalAlpha = p.opacity;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.fillStyle = "#f8f8f8";
        ctx.font = `${p.fontSize}px 'PPEiko', serif`;
        ctx.fillText(p.char, 0, 0);
        ctx.restore();
      });

      requestAnimationFrame(render);
    };

    render();
    canvas.addEventListener("mousemove", handleMouseMove);

    return () => {
      canvas.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("resize", resizeCanvas);
    };
  }, []);

  return (
    <div className='relative h-[140vh] w-full bg-black flex justify-center bg-cover overflow-clip'>
      {/* background image */}
      <img
        src={`${App_url.image.draw_bg}`}
        alt='Draw bg'
        decoding='async'
        className='absolute bottom-[25cqh] right-0 mr-[10vw] w-full z-[1] h-full object-contain object-right '
      />
      <div className='justify-self-center pointer-events-none'>
        <img
          src={`${App_url.image.draw_title}`}
          alt='Draw title'
          className='relative w-[30vw] h-auto z-[3] object-cover pt-[12px]'
        />
      </div>
      <canvas id='canvas' ref={canvasRef} className='absolute top-0 left-0 w-full h-[140vh] z-[2]' width='1536' height='1021' />
      <span id='info' className='absolute top-[25%] left-[50%] -translate-x-1/2 -translate-y-1/2 text-[#8C1209] text-[var(--fs-base)] z-10 pointer-events-none' style={{ display: 'none' }}>Build your Empire</span>
    </div>
  )
}
export default Draw;